// Shared password strength evaluation — single source of truth.
// Used by LoginConfirmation and SettingsProfileEdit (member password flows).
// Minimum length is 8; the PDF-protection password (TranslationDocuments)
// and linguist-portal password (LinguistInvitationSetup) intentionally keep
// their own thresholds and do NOT use this helper.

export const PASSWORD_MIN_LENGTH = 8;

export const evaluatePasswordStrength = (password) => {
  if (!password) {
    return {
      strength: 0,
      label: "",
      color: "grey",
      checks: null,
      meetsMinimum: false,
    };
  }

  let strength = 0;
  const checks = {
    length: password.length >= PASSWORD_MIN_LENGTH,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };

  // Length is worth 2 points, others 1 each
  if (checks.length) strength += 2;
  if (checks.uppercase) strength += 1;
  if (checks.lowercase) strength += 1;
  if (checks.number) strength += 1;
  if (checks.special) strength += 1;

  // Additional length bonuses
  if (password.length >= 12) strength += 1;
  if (password.length >= 16) strength += 1;

  // Map strength to label and color
  let result;
  if (strength <= 2) {
    result = { strength: 25, label: "Weak", color: "error" };
  } else if (strength <= 4) {
    result = { strength: 50, label: "Fair", color: "warning" };
  } else if (strength <= 6) {
    result = { strength: 75, label: "Good", color: "info" };
  } else {
    result = { strength: 100, label: "Strong", color: "success" };
  }

  return { ...result, checks, meetsMinimum: checks.length };
};